import { render } from "./InfoWithIcon.vue?vue&type=template&id=393b04aa"
import script from "./InfoWithIcon.vue?vue&type=script&lang=js"
export * from "./InfoWithIcon.vue?vue&type=script&lang=js"
script.render = render

export default script